import { deleteCookie } from "./cookie";
import { API_TOKENS } from "../constants/api";

export const userReset = () => {
  deleteCookie(API_TOKENS.access);
  deleteCookie(API_TOKENS.refresh);
};
